import { asyncRouterMap, constantRouterMap } from "@/router/index";

//判断是否有权限访问该菜单
function hasPermission(menus, route) {
  if (route.name) {
    let currMenu = getMenu(route.name, menus);
    if (currMenu != null) {
      //设置菜单的标题、图标和可见性
      if (currMenu.title != null && currMenu.title !== "") {
        route.meta.title = currMenu.title;
      }
      if (currMenu.icon != null && currMenu.title !== "") {
        route.meta.icon = currMenu.icon;
      }
      if (currMenu.hidden != null) {
        route.hidden = currMenu.hidden !== 0;
      }
      if (currMenu.sort != null && currMenu.sort !== "") {
        route.sort = currMenu.sort;
      }
      return true;
    } else {
      route.sort = 0;
      if (route.hidden !== undefined && route.hidden === true) {
        return true;
      } else {
        return false;
      }
    }
  } else {
    return true;
  }
}

//根据路由名称获取菜单
function getMenu(name, menus) {
  for (let i = 0; i < menus.length; i++) {
    let menu = menus[i];
    if (name === menu.name) {
      return menu;
    }
  }
  return null;
}

//对菜单进行排序
function sortRouters(accessedRouters) {
  for (let i = 0; i < accessedRouters.length; i++) {
    let router = accessedRouters[i];
    if (router.children && router.children.length > 0) {
      router.children.sort(compare("sort"));
    }
  }
  accessedRouters.sort(compare("sort"));
}

//降序比较函数
function compare(p) {
  return function (m, n) {
    let a = m[p];
    let b = n[p];
    return b - a;
  };
}

const permission = {
  state: {
    routers: constantRouterMap,
    addRouters: [],
  },
  mutations: {
    SET_ROUTERS: (state, routers) => {
      state.addRouters = routers;
      state.routers = constantRouterMap.concat(routers);
    },
  },
  actions: {
    GenerateRoutes({ commit }, data) {
      return new Promise((resolve) => {
        /*var realData = {
          menus: [
            {
              id: 27,
              parentId: 0,
              createTime: "2020-10-18T06:10:16.000+00:00",
              title: "我的药房",
              level: 0,
              sort: 300,
              name: "phms",
              icon: "ums",
              hidden: 0,
            },
            {
              id: 29,
              parentId: 27,
              createTime: "2020-10-18T06:17:39.000+00:00",
              title: "产品列表",
              level: 1,
              sort: 200,
              name: "drugs",
              icon: "ums",
              hidden: 0,
            },
            {
              id: 30,
              parentId: 27,
              createTime: "2020-10-18T06:17:39.000+00:00",
              title: "订单",
              level: 1,
              sort: 100,
              name: "orders",
              icon: "ums",
              hidden: 0,
            },
            {
              id: 31,
              parentId: 0,
              createTime: "2020-10-18T06:10:16.000+00:00",
              title: "供应商管理",
              level: 0,
              sort: 300,
              name: "srm",
              icon: "ums",
              hidden: 0,
            },
            {
              id: 32,
              parentId: 31,
              createTime: "2020-10-18T06:17:39.000+00:00",
              title: "供应商列表",
              level: 1,
              sort: 200,
              name: "supplist",
              icon: "ums",
              hidden: 0,
            },
            {
              id: 33,
              parentId: 31,
              createTime: "2020-10-18T06:17:39.000+00:00",
              title: "代表列表",
              level: 1,
              sort: 100,
              name: "salesman",
              icon: "ums",
              hidden: 0,
            },
            {
              id: 34,
              parentId: 31,
              createTime: "2020-10-18T06:17:39.000+00:00",
              title: "老师列表",
              level: 1,
              sort: 99,
              name: "doctors",
              icon: "ums",
              hidden: 0,
            },
            {
              id: 35,
              parentId: 31,
              createTime: "2020-10-18T06:17:39.000+00:00",
              title: "产品清单",
              level: 1,
              sort: 98,
              name: "platdrugs",
              icon: "ums",
              hidden: 0,
            },
            {
              id: 36,
              parentId: 31,
              createTime: "2020-10-18T06:17:39.000+00:00",
              title: "推荐产品",
              level: 1,
              sort: 97,
              name: "recommendeddrugs",
              icon: "ums",
              hidden: 0,
            },
            {
              id: 37,
              parentId: 31,
              createTime: "2020-10-18T06:17:39.000+00:00",
              title: "药房列表",
              level: 1,
              sort: 96,
              name: "pharmacys",
              icon: "ums",
              hidden: 0,
            },
          ],
          username: "medicine-admin",
        };*/
        const { menus } = data;
        const { username } = data;
        const accessedRouters = asyncRouterMap.filter((v) => {
          //admin帐号直接返回所有菜单
          // if(username==='admin') return true;
          if (hasPermission(menus, v)) {
            if (v.children && v.children.length > 0) {
              v.children = v.children.filter((child) => {
                if (hasPermission(menus, child)) {
                  return child;
                }
                return false;
              });
              return v;
            } else {
              return v;
            }
          }
          return false;
        });
        //对菜单进行排序
        sortRouters(accessedRouters);
        commit("SET_ROUTERS", accessedRouters);
        resolve();
      });
    },
  },
};

export default permission;
